import { IconProps } from "../../../types/style";

const HamMenuIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;

  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="20" height="4" rx="2" fill={color} />
        <rect y="7" width="20" height="4" rx="2" fill={color} />
        <rect y="14" width="20" height="4" rx="2" fill={color} />
      </svg>
    </div>
  );
};

export default HamMenuIcon;
